import { ProcedureId } from '@/Domain/Procedures'
import { AccountId } from '@/Domain/Account'
import { AuctionACommandRepositoryError, ConcatenatedBatches } from '@/Domain/AuctionA'
import { ApiClient } from '@/Domain/ApiClient'

export class AxiosAuctionACommandRepository {
  private _apiClient: ApiClient

  constructor (apiClient: ApiClient) {
    this._apiClient = apiClient
  }

  async sendAuctionAData (
    procedureId: ProcedureId,
    userId: AccountId,
    concatenatedBatches: ConcatenatedBatches,
    data: string
  ): Promise<boolean> {
    try {
      const url = '/sobree/api/sobrea/upload'
      await this._apiClient.makePostRequest(
        url,
        {
          procedureId: procedureId.id,
          userId: userId.accountId(),
          batches: concatenatedBatches.value(),
          data: JSON.parse(data)
        }
      )
      return true
    } catch (error) {
      return Promise.reject(new AuctionACommandRepositoryError(error.message))
    }
  }
}
